import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const swiper = new Swiper(".testimonials__messages", {
    modules: [Navigation],
    spaceBetween: 60,
    slidesPerView: 1,
    loop: true,
    navigation: {
        nextEl: ".testimonials__messages-next",
        prevEl: ".testimonials__messages-prev",
    },
});

swiper.on("slideChange", function (evt) {
    const slider = evt.el;
    const showmore = slider
        .querySelector(".swiper-slide-active")
        .querySelector("[data-showmore]");

    const content = showmore.querySelector("[data-showmore-content]");

    if (!content.style.height) {
        content.style.height = getComputedStyle(content).height;
        content.style.transitionDuration = "500ms";
        setTimeout(() => {
            content.style.height = content.dataset.showmoreContent + "px";
        }, 0);
        content.style.overflow = "hidden";
        showmore.classList.remove("_showmore-active");
        window.scrollTo({
            top: slider.getBoundingClientRect().y + window.scrollY - document.documentElement.clientHeight / 100 * 20,
            left: 0,
            behavior: "smooth",
        });
    }
});
